/**
 * Organization Chart CASL helpers.
 *
 * Backend must issue on login (userData.abilities), e.g.:
 *   { action: 'read', subject: 'org_chart' }   — page, nav, view tree
 *   { action: 'manage', subject: 'org_chart' } — show inactive
 *
 * Admin-style `{ action: 'manage', subject: 'all' }` also unlocks everything.
 * Do not rely on client-side initialAbility for production grants.
 */

export const ORG_CHART_SUBJECT = 'org_chart'

function hasPermission(canFn, action, subject) {
  if (typeof canFn !== 'function') return false
  return !!canFn(action, subject)
}

/** Show inactive toggle — manage org_chart or manage all. */
export function canManageOrgChart(canFn) {
  return (
    hasPermission(canFn, 'manage', ORG_CHART_SUBJECT)
    || hasPermission(canFn, 'manage', 'all')
  )
}

/** Open Manage Users profile deep-link. */
export function canViewUserProfile(canFn) {
  return (
    hasPermission(canFn, 'read', 'users')
    || hasPermission(canFn, 'manage', 'users')
    || hasPermission(canFn, 'manage', 'all')
  )
}

